module.exports = __webpack_public_path__ + "img/reserve-firstfinancial-2.8a64a645.png";